import { render, staticRenderFns } from "./ChallengeAdminManagementForm.vue?vue&type=template&id=1f823ba1&"
import script from "./ChallengeAdminManagementForm.vue?vue&type=script&lang=js&"
export * from "./ChallengeAdminManagementForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports